export const HEADLINE_PARTS = [
  { text: "While ", variant: "default" },
  { text: "another roofing company missed the lead", variant: "soft" },
  { text: ", ", variant: "default" },
  { text: "your Digital assistant", variant: "soft" },
  { text: " took this ", variant: "default" },
  { text: "$25,000", variant: "accent" },
  { text: " client.", variant: "default" },
];

export const TIMELINE_STEPS = [
  {
    id: "new-lead",
    timestamp: "22:14:02",
    emoji: "🟢",
    label: "New Lead:",
    message: '"My roof is leaking badly on George St, help!"',
    role: "lead",
  },
  {
    id: "ai-reply",
    timestamp: "22:14:04",
    emoji: "⚡",
    label: "Your AI Intake Rep:",
    message:
      '"Hi Tom — got it. I see you\'re on George St. Is it tile or metal? I\'ll get you on the schedule."',
    role: "employee",
  },
  {
    id: "photos",
    timestamp: "22:14:35",
    emoji: "📸",
    label: "Tom:",
    message: "[Sent 2 photos of chimney damage]",
    role: "client",
  },
  {
    id: "booking",
    timestamp: "22:14:55",
    emoji: "📅",
    label: "Your Digital Assistant:",
    message: "Inspection booked for Thu 9:00 AM (Weather checked: Clear)",
    role: "calendar",
  },
];

export const HERO_STAT_ITEMS = [
  { value: "9 sec", label: "RESPONSE" },
  { value: "72h", label: "LIVE" },
  { value: "0", label: "NEW HIRES" },
  { value: "+6/wk", label: "OZ EXTERIORS" },
];

export const CTA_COPY = {
  summary:
    "A digital employee for your roofing team — not a replacement. Built for Google Search and emergency leak leads: qualifies, logs, and books free inspections in 9 seconds while you're on the roof.",
  button: "Start 14-Day Free Trial — Live in 72 Hours",
  headerButton: "Start Free Trial",
};
